import React from "react";
import { IconPropsType } from "./types";

interface IOrdersIconProps extends IconPropsType {}

const OrdersIcon = ({
  size = 24,
  strokeWidth = 1.25,
  stroke = "var(--rhino)",
  ...props
}: IOrdersIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

export default OrdersIcon;
